import { CustomCarousel } from '../components/CustomCarousel/index';

const BannerWidget = ({ widgetInformation }) => {
  return <CustomCarousel configData={widgetInformation} />;
};

export default BannerWidget;
